<template>
  <v-checkbox
    v-model="selected"
    v-on:click.stop="toggleItemSelection"
    hide-details
    class="node-select-checkbox"
    density="compact"
    :aria-label="$t('routes.node.a11y.selectFolder', { name: node.name })"
  />
</template>

<script>
import { useNodeStore } from '@/stores/NodeStore.js';

export default {
  name: "NodeItemSelect",
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  emits: ['toggleItemSelection'],
  data: function() {
    return {
      selected: false,
    };
  },
  mounted: function() {
    this.selected = this.isSelected;
  },
  methods: {
    toggleItemSelection: function(event) {
      this.$emit('toggleItemSelection', event.shiftKey);
    }
  },
  watch: {
    isSelected: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selected = newValue;
      }
    }
  },
  computed: {
    isSelected: function() {
      const nodeStore = useNodeStore();
      const selectedNodes = nodeStore.getSelectedNodes;

      return selectedNodes.indexOf(this.node) >= 0;
    }
  },
}
</script>

<style lang="scss">
.node-select-checkbox {
  margin: 0;
  padding: 0;

  :deep(.v-selection-control) {
    align-items: center;
    min-height: 0;
    width: 25px;
    height: 25px;
  }
}

.node-select-checkbox .v-selection-control--dirty .v-icon {
  color: var(--v-theme-primary) !important;
}
</style>
